import { styled } from 'styled-components'
import { Card, CardProps } from '@pancakeswap/uikit'

export const BodyWrapper = styled(Card)`
  border-radius: 25px;
  max-width: 436px;
  @media (max-width: 767px) {
    & {
      width: 100%;
    }
  }
  
  z-index: 1;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  margin-bottom: 15px;
  background: ${({ theme }) => theme.colors.backgroundAlt};
  box-shadow: 0 16px 40px -16px rgba(0, 0, 0, 0.6);
`

/**
 * The styled container element that wraps the content of most pages and the tabs.
 */
export default function AppBody({ children, ...cardProps }: { children: React.ReactNode } & CardProps) {
  return <BodyWrapper {...cardProps}>{children}</BodyWrapper>
}
